<template>
  <div :class="brandClasses.reviewsSearchWrapper">
    <p v-if="reviewsCount" class="text-base <lg:mb-2 ">
      {{ replaceAll($pluralize($t.reviewedByCustomers, reviewsCount), { count: reviewsCount }) }}
    </p>
    <div v-if="$feature.showReviewSearchOnPDP">
      <form
        :aria-label="$t.reviews"
        class="flex"
        :class="brandClasses.reviewsSearchForm"
        role="search"
        @submit.prevent="emit('search')"
      >
        <vf-input :class="brandClasses.reviewsSearchInput">
          <template #input>
            <base-input
              v-model="searchTerm"
              :aria-label="$t.searchReviews"
              class="h-full"
              maxlength="200"
              :placeholder="`${$t.searchReviews}...`"
              type="text"
              @change="emit('update:model-value', $event)"
            />
          </template>
          <template #end>
            <base-button
              v-if="searchTerm"
              :aria-label="$t.searchClearLabel"
              @click="clearSearch"
            >
              <vf-icon name="clear" :size="iconSize" />
            </base-button>
          </template>
        </vf-input>
        <base-button
          :aria-label="$t.searchButtonLabel"
          :class="brandClasses.reviewsSearchSubmit"
          type="submit"
        >
          <vf-icon name="search" :size="iconSize" />
        </base-button>
      </form>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IconSizes } from '#types/sizes'

defineProps<{
  iconSize: IconSizes
  reviewsCount: number
}>()

const emit = defineEmits<{
  'search': []
  'update:model-value': [value: string]
}>()

const { brandClasses } = useAppConfig().pages.pdp

const searchTerm = defineModel<string>()

const clearSearch = () => {
  searchTerm.value = ''
  emit('search')
}
</script>
